<form [formGroup]="locationDataFG" *ngIf="locationDataFG" class="ui-g location-data-container component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'basic-profile.jurisdiction.page-title' | translate }}</div>
  </div>

  <ng-container *ngIf="showCopyApplicationDataSection">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-section-header
        [title]="'basic-profile.jurisdiction.copy-application-title' | translate"
        [tooltip]="'tooltips.jurisdiction.copy-application' | translate"></app-section-header>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-copy-application-data
        [copyApplicationId]="application?.copy_application_id"
        *ngIf="currentInstallationFlow"
        [installationFlow]="currentInstallationFlow"
        (dataCopied)="dataCopied()"></app-copy-application-data>
    </div>
  </ng-container>

  <ng-container *ngIf="isRegEP && showTotalFeedInPowerOfTheEnergyProducer">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-section-header
        [title]="'basic-profile.jurisdiction.request' | translate"
        [tooltip]="'tooltips.jurisdiction.request' | translate"></app-section-header>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-regep-jurisdiction
        (regEpJurisdictionDataChange)="regEpJurisdictionDataChange($event)"
        [isTotalFeedInPowerAbove]="locationDataFG.value.totalFeedInPowerIsAboveCentralGridThreshold"
        [gridCompOrderNumber]="locationDataFG.value.gridCompExternalId"></app-regep-jurisdiction>
    </div>
  </ng-container>

  <ng-container *ngIf="!locationDataFG.value.totalFeedInPowerIsAboveCentralGridThreshold">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-section-header
        [title]="'basic-profile.jurisdiction.form-title' | translate"
        [tooltip]="'tooltips.jurisdiction.address-info' | translate"
        [showTooltip]="infoBubblesData?.showAddressInfo"></app-section-header>
    </div>

    <div *ngIf="showAddress" id="location-input" class="ui-lg-10 ui-md-10 ui-sm-12 ui-xs-12 margin-align">
      <label class="field-label" [ngClass]="!isAddressNotRequired ? 'required' : ''" for="formattedAddress">
        {{ 'basic-profile.fields.address' | translate }}
      </label>

      <p-dropdown
        #locationSelect
        [options]="locationOptions$ | async"
        optionLabel="formattedAddress"
        formControlName="location"
        placeholder="{{ 'basic-profile.fields.enter_location' | translate }}"
        id="formattedAddress"
        tabindex="0"
        (onChange)="selectLocation($event.value)"
        [filter]="true"
        appEnterClick></p-dropdown>
    </div>

    <div *ngIf="showAddress" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 location-section">
      <div class="location-map">
        <app-apt-map (sendGPS)="updateLocationValues($event)" [coordinates]="gpsCoordinates"></app-apt-map>
      </div>
    </div>

    <div
      *ngIf="(!isGridCompatibility && !isRegEP) || ((isGridCompatibility || isRegEP) && !this.locationDataFG.value.useAreaLocation)"
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-section form-font-size">
      <ng-container *ngIf="showNewDevAreaDetails && currentInstallationFlow === installationFlowType.MainsConnection">
        <div class="ui-g-12 checkbox-field-row margin-align">
          <p-radioButton
            formControlName="newDevArea"
            id="existing-development-area"
            tabindex="0"
            label="{{ 'basic-profile.jurisdiction.development-area-existing' | translate }}"
            class="radio-field"
            name="developmentAreaGroup"
            [value]="false"></p-radioButton>
          <p-radioButton
            formControlName="newDevArea"
            id="new-development-area2"
            tabindex="0"
            label="{{ 'basic-profile.jurisdiction.development-area-new' | translate }}"
            class="radio-field padding-left-1"
            name="developmentAreaGroup"
            [value]="true"></p-radioButton>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          showNewDevAreaDetails &&
          (currentInstallationFlow === installationFlowType.MainsConnection ||
            currentInstallationFlow === installationFlowType.TemporaryConnection ||
            currentInstallationFlow === installationFlowType.ConversionToGas)
        ">
        <div class="ui-g-12 checkbox-field-row margin-align">
          <p-checkbox
            appEnterClick
            (onChange)="updateFormSwsValues($event.checked)"
            binary="true"
            class="checkbox-field"
            formControlName="noAddressAvailable"
            id="no-address-available"
            tabindex="0"
            label="{{ 'basic-profile.jurisdiction.no-address-available' | translate }}"></p-checkbox>
        </div>
      </ng-container>
    </div>

    <!-- NEW LSW FEATURE  -->
    <ng-container>
      <div class="ui-g-12 top-margin location-installation-section mb-3">
        <div class="ui-g-4 ui-xs-12 center_aligned">
          <label class="field-label">{{ 'grid-comp.use-area-location' | translate }}</label>
          <p-checkbox
            appEnterClick
            formControlName="useAreaLocation"
            name="useAreaLocation"
            (click)="toggleAreaFields()"
            binary="true"></p-checkbox>
        </div>
      </div>

      <div *ngIf="useAreaLocation" class="ui-g-12 top-margin location-installation-section">
        <div *ngIf="!useDropdownForArea" class="ui-g-4 ui-xs-12 center_aligned">
          <label class="field-label required">{{ 'grid-comp.area' | translate }}</label>
          <input type="text" pInputText formControlName="area" name="area" [required]="false" />
        </div>
        <div *ngIf="useDropdownForArea" class="ui-g-4 ui-xs-12 center_aligned">
          <label class="field-label required">{{ 'grid-comp.area' | translate }}</label>
          <p-dropdown
            id="area-options"
            tabindex="0"
            [options]="areaOptions"
            optionLabel="area"
            [filter]="true"
            placeholder="-Select-"
            pInputText
            (onChange)="selectArea($event.value)"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="selectedArea"></p-dropdown>
        </div>
        <div class="ui-g-4 ui-xs-12 center_aligned">
          <label class="field-label required">{{ 'grid-comp.field' | translate }}</label>
          <input type="text" pInputText formControlName="field" name="field" [required]="false" />
        </div>
        <div class="ui-g-4 ui-xs-12 center_aligned">
          <label class="field-label required">{{ 'grid-comp.field-sector' | translate }}</label>
          <input type="text" pInputText formControlName="field_sector" name="field_sector" [required]="false" />
        </div>
      </div>
      <div *ngIf="useAreaLocation && locationDataFG.controls.other_area" class="ui-g-12 location-installation-section">
        <div class="ui-g-4 ui-xs-12 pt-0 center_aligned">
          <label class="field-label required hidden">{{ 'grid-comp.area' | translate }}</label>
          <input class="other-area" type="text" maxlength="40" pInputText formControlName="other_area" name="other_area" />
        </div>
      </div>
    </ng-container>

    <!-- NEW LSW FEATURE  -->
    <div *ngIf="showNewDevAreaDropdownForConnection || showNewDevAreaDropdownForInstallation" class="ui-g-12 form-section form-font-size">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <p-checkbox
            appEnterClick
            (onChange)="displayAreaName($event)"
            binary="true"
            class="checkbox-field"
            formControlName="newDevArea"
            id="new-development-area"
            tabindex="0"
            label="{{ 'basic-profile.jurisdiction.new-development-area' | translate }}"></p-checkbox>
        </div>

        <div *ngIf="showAreaName" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label class="ui-g-5 field-label text-right-align required">
            {{ 'basic-profile.jurisdiction.development-area-name' | translate }}
          </label>
          <input
            *ngIf="showParcelNumberTextBox"
            class="h4-button-and-field ui-input pInputText filed-width"
            formControlName="devAreaName"
            id="float-input-dev-area"
            tabindex="0"
            pInputText
            size="30"
            type="text" />
          <p-dropdown
            *ngIf="!showParcelNumberTextBox"
            [options]="devAreaTypes"
            formControlName="devAreaName"
            id="water-heating-type"
            tabindex="0"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <div
        *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && showAreaName && showOrderMessage"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          {{ 'basic-profile.jurisdiction.location-disclaimer' | translate }}
        </div>
      </div>
    </div>

    <div
      *ngIf="
        showNewDevAreaDetails &&
        (currentInstallationFlow === installationFlowType.MainsConnection ||
          currentInstallationFlow === installationFlowType.TemporaryConnection ||
          currentInstallationFlow === installationFlowType.ConversionToGas) &&
        locationDataFG?.get('noAddressAvailable').value
      "
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="ui-g-6 margin-align">
        <label class="ui-g-5 field-label text-right-align required" for="sws-subdistrict">
          {{ 'basic-profile.jurisdiction.sws-subdistrict' | translate }}
        </label>
        <input
          appAlphaNumSpecial="true"
          class="ui-input pInputText filed-width"
          formControlName="swsDevAreaSubDistrict"
          id="sws-subdistrict"
          tabindex="0"
          pInputText
          size="30" />
      </div>
      <div class="ui-g-6 margin-align">
        <label class="ui-g-5 field-label text-right-align required" for="sws-parcel">
          {{ 'basic-profile.jurisdiction.sws-parcel' | translate }}
        </label>
        <input
          appAlphaNumSpecial="true"
          class="ui-input pInputText filed-width"
          formControlName="swsParcel"
          id="sws-parcel"
          tabindex="0"
          pInputText
          size="30" />
      </div>
      <div class="ui-g-6 margin-align">
        <label class="ui-g-5 field-label text-right-align required" for="sws-parcel-no">
          {{ 'basic-profile.jurisdiction.sws-parcel-no' | translate }}
        </label>
        <input
          appAlphaNumSpecial="true"
          class="ui-input pInputText filed-width"
          formControlName="swsParcelNumber"
          id="sws-parcel-no"
          tabindex="0"
          pInputText
          size="30" />
      </div>
      <div class="ui-g-6 margin-align">
        <label class="ui-g-5 field-label text-right-align" for="sws-dev-area-name">
          {{ 'basic-profile.jurisdiction.sws-development-area-name' | translate }}
        </label>
        <input
          appAlphaNumSpecial="true"
          class="ui-input pInputText filed-width"
          formControlName="swsDevAreaName"
          id="sws-dev-area-name"
          tabindex="0"
          pInputText
          size="30" />
      </div>
    </div>

    <!--	<div class="ordnance-warning" *ngIf="showOrdnanceWarning">-->
    <!--		<i class="pi pi-exclamation-circle info-icon"></i>-->
    <!--		<span>{{'basic-profile.jurisdiction.ordnance-warning-text' | translate}}</span>-->
    <!--	</div>-->

    <div
      class="ordnance-warning"
      *ngIf="
        newBuildingWarning &&
        (showOrdnanceWarning || showWarningText) &&
        showNewDevAreaDetails &&
        currentInstallationFlow === installationFlowType.MainsConnection
      ">
      <i class="pi pi-exclamation-circle info-icon"></i>
      <span [innerHTML]="'basic-profile.jurisdiction.new-building-warning-text' | translate"></span>
    </div>
    <div
      class="ordnance-warning"
      *ngIf="
        !newBuildingWarning &&
        (showOrdnanceWarning || showWarningText) &&
        showNewDevAreaDetails &&
        currentInstallationFlow === installationFlowType.MainsConnection
      ">
      <i class="pi pi-exclamation-circle info-icon"></i>
      <span [innerHTML]="'basic-profile.jurisdiction.existing-building-warning-text' | translate"></span>
    </div>
    <div
      class="ordnance-warning"
      *ngIf="newBuildingWarning && showNewDevAreaDetails && currentInstallationFlow === installationFlowType.MainsConnection">
      <i class="pi pi-exclamation-circle info-icon"></i>
      <span [innerHTML]="'basic-profile.jurisdiction.new-building-help-text' | translate"></span>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <app-section-header
        [title]="'basic-profile.jurisdiction.request' | translate"
        [tooltip]="'tooltips.jurisdiction.request' | translate"
        [showTooltip]="infoBubblesData?.showAddressInfo"></app-section-header>
    </div>

    <app-connection-type
      *ngIf="isUsePowerConnectionTypeForNewMains && locationDataFG?.controls?.connectionType && locationDataFG?.controls?.power?.value"
      [form]="locationDataFG?.controls?.connectionType"></app-connection-type>

    <div
      *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && !isConversionToGas && !hideBuildingTypesForNewMains"
      class="ui-g-12 top-margin form-section form-font-size">
      <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <p-radioButton
          [value]="buildingTypes[0].value"
          formControlName="buildingType"
          id="single-family-checkbox"
          tabindex="0"
          label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[0]?.value + '.name' | translate }}"
          name="buildingTypeGroup"></p-radioButton>
      </div>

      <div class="ui-g-7 building-type-selectors" [class.reverse]="reverseBuildingTypes">
        <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
          <p-radioButton
            [value]="buildingTypes[1].value"
            formControlName="buildingType"
            id="multi-family-checkbox"
            tabindex="0"
            label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[1]?.value + '.name' | translate }}"
            name="buildingTypeGroup"></p-radioButton>
        </div>

        <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding" *ngIf="showApartmentOverSix">
          <p-radioButton
            [value]="buildingTypes[2].value"
            formControlName="buildingType"
            id="apartment-house-1"
            tabindex="0"
            label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[2]?.value + '.name' | translate }}"
            name="buildingTypeGroup"></p-radioButton>
        </div>
      </div>
      <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
        <p-radioButton
          [value]="buildingTypes[3].value"
          formControlName="buildingType"
          id="apartment-house-2"
          tabindex="0"
          label="{{ 'lookup.' + buildingTypeKey + '.options.' + buildingTypes[3]?.value + '.name' | translate }}"
          name="buildingTypeGroup"></p-radioButton>
      </div>
    </div>

    <div *ngIf="showMediaSelectionBoxes()" class="ui-g-12 top-margin location-installation-section">
      <div class="ui-g-3 ui-xs-12 center_aligned" *ngIf="mediumVisibility.power">
        <span
          #checkboxElement
          (click)="selectMeter($event, 'power')"
          class="icon icon-electricity pointer-cursor"
          id="power"
          tabindex="0"
          appEnterClick></span>
        <div class="icon-label">{{ 'overview.details-data.data-rows.power' | translate }}</div>
        <div class="meter-type-dropdown">
          <p-dropdown
            *ngIf="showDropdowns"
            [options]="installationChangeTypes"
            formControlName="powerType"
            id="jurisdiction-power-dropdown"
            tabindex="0"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + installationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + installationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
          <div class="align-marker" *ngIf="showDropdowns && locationDataFG?.value['power']">
            <label class="required"></label>
          </div>
        </div>
      </div>

      <div
        *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection && mediumVisibility.gas"
        class="ui-g-3 ui-xs-12 center_aligned">
        <span
          #checkboxElement
          (click)="selectMeter($event, 'gas')"
          class="icon icon-gas pointer-cursor"
          id="gas"
          tabindex="0"
          appEnterClick></span>
        <div class="icon-label">{{ 'overview.details-data.data-rows.gas' | translate }}</div>
        <div class="meter-type-dropdown">
          <p-dropdown
            *ngIf="showDropdowns"
            [options]="gasInstallationChangeTypes"
            formControlName="gasType"
            id="jurisdiction-gas-dropdown"
            tabindex="0"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
          <div class="align-marker" *ngIf="showDropdowns && locationDataFG?.value['gas']">
            <label class="required"></label>
          </div>
        </div>
      </div>
      <div class="ui-g-3 ui-xs-12 center_aligned" *ngIf="mediumVisibility.water">
        <span
          #checkboxElement
          (click)="selectMeter($event, 'water')"
          class="icon icon-water pointer-cursor"
          id="water"
          tabindex="0"
          appEnterClick></span>
        <div class="icon-label">{{ 'overview.details-data.data-rows.water' | translate }}</div>
        <div class="meter-type-dropdown">
          <p-dropdown
            *ngIf="showDropdowns"
            [options]="waterInstallationChangeTypes"
            formControlName="waterType"
            id="jurisdiction-water-dropdown"
            tabindex="0"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
          <div class="align-marker" *ngIf="showDropdowns && locationDataFG?.value['water']">
            <label class="required"></label>
          </div>
        </div>
      </div>
      <div *ngIf="showWaterNote" class="top-margin">
        {{ 'basic-profile.jurisdiction.water-subproduct-hint' | translate }}
      </div>
      <div
        *ngIf="currentInstallationFlow !== installationFlowType.TemporaryConnection && mediumVisibility.heating"
        class="ui-g-3 ui-xs-12 center_aligned">
        <span
          #checkboxElement
          (click)="selectMeter($event, 'heating')"
          class="icon icon-geothermal pointer-cursor"
          id="heating"
          tabindex="0"
          appEnterClick></span>
        <div class="icon-label">{{ 'overview.details-data.data-rows.heating' | translate }}</div>
        <div class="meter-type-dropdown">
          <p-dropdown
            *ngIf="showDropdowns"
            [options]="heatingInstallationChangeTypes"
            formControlName="heatingType"
            id="jurisdiction-heating-dropdown"
            tabindex="0"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
          <div class="align-marker" *ngIf="showDropdowns && locationDataFG?.value['heating']">
            <label class="required"></label>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="this.currentInstallationFlow === this.installationFlowType.ConsumptionDevices"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
      <app-drr-ccd-devices-jurisdiction
        [initialData]="application"
        (formInitiated)="consumptionDevicesFormInitiated($event)"></app-drr-ccd-devices-jurisdiction>
    </div>

    <div *ngIf="isFeedSystem" class="ui-g-12 top-margin location-installation-section">
      <div class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          formControlName="construction-type"
          name="construction-type"
          [value]="feedInTypes[0].value"
          (onClick)="setFeedInInstType(feedInTypes[0].value)"></p-radioButton>
        <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[0].value + '.name' | translate }}</label>
      </div>
      <div class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          formControlName="construction-type"
          name="construction-type"
          [value]="feedInTypes[1].value"
          (onClick)="setFeedInInstType(feedInTypes[1].value)"></p-radioButton>
        <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[1].value + '.name' | translate }}</label>
      </div>
      <div *ngIf="showDecommissioningInFeedInSystem" class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          formControlName="construction-type"
          name="construction-type"
          [value]="feedInTypes[2].value"
          (onClick)="setFeedInInstType(feedInTypes[2].value)"></p-radioButton>
        <label class="field-label">{{ 'lookup.' + feedInTypeKey + '.options.' + feedInTypes[2].value + '.name' | translate }}</label>
      </div>
    </div>

    <div *ngIf="isChangeConnection" class="ui-g-12 top-margin location-installation-section">
      <div class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          [value]="changeRequestTypes[0].value"
          formControlName="connectionModification"
          name="connection-modification"></p-radioButton>
        <label class="field-label">{{ 'basic-profile.fields.close-connection' | translate }}</label>
      </div>
      <div class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          [value]="changeRequestTypes[1].value"
          formControlName="connectionModification"
          name="connection-modification"></p-radioButton>
        <label class="field-label">{{ 'basic-profile.fields.reinforce-connection' | translate }}</label>
      </div>
      <div class="ui-g-4 ui-xs-12 center_aligned">
        <p-radioButton
          [value]="changeRequestTypes[2].value"
          formControlName="connectionModification"
          name="connection-modification"></p-radioButton>
        <label class="field-label">{{ 'basic-profile.fields.relocation-connection' | translate }}</label>
      </div>
    </div>

    <div *ngIf="locationDataFG?.get('mediaConversion')" class="ui-g-12 margin-align conversion-checkbox form-font-size">
      <p-checkbox
        appEnterClick
        (onChange)="onSelectingConversion($event)"
        binary="true"
        class="checkbox-field"
        formControlName="mediaConversion"
        id="show-conversion-checkbox"
        tabindex="0"
        label="{{ 'installation-data.conversion-to-gas' | translate }}"></p-checkbox>
    </div>

    <div *ngIf="isConversionToGas" class="ui-g-12 top-margin location-installation-section">
      <div class="ui-g-6 ui-xs-12 center_aligned">
        <p-radioButton [value]="changeRequestTypes[3].value" formControlName="conversionType" name="conversionType"></p-radioButton>
        <label class="field-label">{{ 'basic-profile.fields.on-gas' | translate }}</label>
      </div>
      <div *ngIf="!hideConversionOnHeatingRadioButton" class="ui-g-6 ui-xs-12 center_aligned">
        <p-radioButton [value]="changeRequestTypes[4].value" formControlName="conversionType" name="conversionType"></p-radioButton>
        <label class="field-label">{{ 'basic-profile.fields.on-heating' | translate }}</label>
      </div>
    </div>

    <div class="ui-g-12 top-margin text-center jurisdiction-check-section" *ngIf="showJurisdictionCheckButton()">
      <button
        (click)="verifyServiceAvailability()"
        [disabled]="disableFormButtons || isLoading"
        class="responsibility-check-btn"
        label="{{
          isFeedSystem && showFeedInSystemJurisdictionCheckLabel
            ? ('basic-profile.jurisdiction.juri_check' | translate | uppercase)
            : ('basic-profile.jurisdiction.check_resp' | translate | uppercase)
        }}"
        pButton></button>
      <div class="error-message ordnance-warning jurisdiction-message" *ngIf="jurisdictionCheckMessage">
        <i class="pi pi-exclamation-circle info-icon"></i>
        <span>{{ jurisdictionCheckMessage }}</span>
      </div>
    </div>
  </ng-container>

  <div class="ui-g-12 submit-button-section text-center">
    <button
      (click)="submitFormData()"
      [disabled]="disabledSubmitButton() || isLoading"
      class="submit-button"
      label="{{ 'basic-profile.jurisdiction.continue' | translate | uppercase }}"
      pButton></button>
  </div>

  <p-confirmDialog
    data-testId="new-app-confirm"
    #confirmDialog
    icon="pi pi-info-circle"
    message="{{ 'basic-profile.jurisdiction.new-application-confirm-text' | translate }}"
    styleClass="netz-confirm-dialog">
    <p-footer>
      <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
      <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
    </p-footer>
  </p-confirmDialog>
</form>
<app-loader *ngIf="isLoading || loadingGPS"></app-loader>
